module.exports = __webpack_public_path__ + "img/knausgaard_Portrett1.cf5ef111.jpg";